const parseDateString = (dateString, locale) => {
    return new Date(dateString).toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });
};

export default parseDateString;
